import styled from '@emotion/styled';
import { Body } from '@components/templates/PageBody';

export const LicenseInfoBody = styled(Body)`
  margin-top: 18px;
  min-width: 505px;
  table {
    width: 100%;
    tbody > tr > td {
      background-color: #f5f5f5;
    }

    th {
      width: 260px;
    }
  }
`;

export const LicenseIcon = styled.div`
  margin: 60px 20px;
  width: 120px;
  height: 120px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & > img {
    width: 120px;
    height: 120px;
    padding: 20px;
  }
`;

export const ProductSection = styled.div`
  display: flex;
  align-items: center;
  & > img {
    width: 25px;
    height: 25px;
  }
  & > label {
    font-family: Noto Sans KR;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
    color: #555555;
    margin: 0 10px;
    display: flex;
    justify-content: center;
    align-items: baseline;
    p {
      margin: 0 10px;
      align-items: baseline;
      font-weight: normal;
      font-size: 16px;
      color: #999999;
    }
  }
  & .superscript {
    font-size: 14px;
    vertical-align: super;
  }
`;

export const NOTavailable = styled.td`
  cursor: pointer;
  text-decoration: underline;
  div {
    display: flex;
    align-items: center;
    b {
      color: #00bf00;
    }
    & > div {
      margin-left: 6px;
      background-color: #ffffff;
    }
    &:hover > div {
      border-color: #7fe200;
      background-color: #effdda;
    }
    &:active > div {
      border-color: #7fe200;
      background-color: #7fe200;
      :before,
      :after {
        border-color: #ffffff;
      }
    }
  }
`;

export const Divider = styled.div`
  border-top: 1px solid #e0e0e0;
  height: 0;
  width: 300px;
  margin: 20px auto;
`;

export const ContactBox = styled.div`
  img {
    height: 14px;
    width: auto;
  }
  div {
    line-height: 40px;
    color: #555555;
  }
`;
